import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import { JDImage, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib';
import { pt, jumpByUrl } from '../../../components/utiles';

export default class FloatEntry extends PureComponent {
    static defaultProps = {
        iconUrl: '',
        url: '',
        mtaData: {},
        onPress: null,
        withShadow: true,
        style: {},
        fromPage: '',
        onBeforeJump: () => {}
    }

    constructor(props) {
        super(props);
        this._onPress = this._onPress.bind(this);
    }

    _onPress() {
        const {
            onPress,
            url,
            onBeforeJump
        } = this.props;
        if (onPress && typeof onPress === 'function') {
            onPress();
            return;
        }
        if (url) {
            if (onBeforeJump && typeof onBeforeJump === 'function') {
                onBeforeJump();
            }
            jumpByUrl(url);
        }
    }

    render() {
        const {
            iconUrl,
            style,
            withShadow
        } = this.props;
        return (

            <View style={[floatEntryStyle.item, withShadow ? floatEntryStyle.itemWithShadow : {}, style]} className={withShadow ? 'floatEntryShadow' : ''}>
                <JDTouchableWithoutFeedback onPress={this._onPress}>
                    <JDImage containerStyle={floatEntryStyle.itemIconWrap} style={floatEntryStyle.itemIcon} source={{ uri: iconUrl}} resizeMode='contain' />
                </JDTouchableWithoutFeedback>
            </View>
        );
    }
}

FloatEntry.propTypes = {
    iconUrl: PropTypes.string.isRequired,
    url: PropTypes.string,
    floatEntry: PropTypes.bool,
    onPress: PropTypes.func,
    style: PropTypes.object,
    mtaData: PropTypes.object,
    fromPage: PropTypes.string
};

const floatEntryStyle = StyleSheet.create({
    item: {
        position: 'absolute',
        right: pt(24),
        bottom: pt(200),
        alignItems: 'center',
        justifyContent: 'center',
        width: pt(80),
        height: pt(80),
        borderRadius: pt(40),
        // overflow: 'hidden',
        backgroundColor: '#fff',
        borderWidth: pt(1),
        borderColor: '#D6D6D6'
    },
    itemWithShadow: {
        borderRadius: pt(40),
        shadowColor: '#000',
        shadowOpacity: 0.08,
        shadowOffset: {
            height: pt(8)
        },
        shadowRadius: pt(24),
        elevation: 2
    },
    itemIconWrap: {
        width: pt(40),
        height: pt(40)
    },
    itemIcon: {
        width: '100%',
        height: '100%'
    }
});
